// extracted by mini-css-extract-plugin
export default {"arrow":"CarouselArrow_arrow__tnb3F","arrowLeft":"CarouselArrow_arrowLeft__oQkHW","arrowRight":"CarouselArrow_arrowRight__WAx5P"};